import HttpService from "../util/HttpService";
import {AdminRequestDto} from "../dto/admin/AdminRequestDto";
import {IndividualAccountWrapperDto} from "../dto/IndividualAccountWrapperDto";
import {FundDetailDto} from "../dto/admin/FundDetailDto";
import {CurrentYieldDetailDto} from "../dto/admin/CurrentYieldDetailDto";
import {CustomerFilterDto} from "../dto/admin/CustomerFilterDto";
import {UserMstDto} from "../dto/UserMstDto";
import ParamEncrypt from "../util/ParamEncrypt";
import {UserMstFilterDto} from "../dto/admin/UserMstFilterDto";
import {TransactionTableResyncDto} from "../dto/admin/TransactionTableResyncDto";

const CONTEXT_PATH = "/cwm/api/v2";
const SERVICE_PATH = "/admin-service/";

class AdminService {

    // get pending task lists of detail,video,customer
    getPendingCustomerVerificationWorkList = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-customer-verification-work-list/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }
    getPendingDetailVerificationWorkList = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-detail-verification-work-list/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }
    getPendingVideoVerificationWorkList = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-video-verification-work-list/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }

    // get assigned task lists of detail,video,customer
    getAssignedDetailVerificationWorkListByUser = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-assigned-detail-verification-work-list-by-user/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }
    getAssignedVideoVerificationWorkListByUser = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-assigned-video-verification-work-list-by-user/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }
    getAssignedCustomerVerificationWorkListByUser = (adminWorkType: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-assigned-customer-verification-work-list-by-user/").concat(ParamEncrypt.encryptData(adminWorkType)));
    }

    //assign task to workbasket
    assignDetailVerificationTaskToWorkbasket = (adminWorkType: string, workId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("assign-detail-verification-work-to-customer/").concat(ParamEncrypt.encryptData(adminWorkType)).concat("/") + ParamEncrypt.encryptData(String(workId)));
    }
    assignVideoVerificationTaskToWorkbasket = (adminWorkType: string, workId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("assign-video-verification-work-to-customer/").concat(ParamEncrypt.encryptData(adminWorkType)).concat("/") + ParamEncrypt.encryptData(String(workId)));
    }

    getCustomerDetailsForVerification = (workId: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-customer-details-for-verification/") + ParamEncrypt.encryptData(String(workId)));
    }

    // verify customer,video,detail

    verifyDetail = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("verify-detail"), ParamEncrypt.encryptObject(adminRequestDto));
    }
    verifyVideo = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("verify-video"), ParamEncrypt.encryptObject(adminRequestDto));
    }
    verifyCustomer = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("verify-customer"), ParamEncrypt.encryptObject(adminRequestDto));
    }

    getVideoVerificationScheduleDates = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get_video_verification_schedule_dates"));
    }
    getVideoVerificationScheduleSlots = (selectedDate: any) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get_video_verification_schedule_slots/") + selectedDate);
    }
    rescheduleVideoVerification = (data: any) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("reschedule_video_verification"), ParamEncrypt.encryptObject(data));
    }

    //transfer tasks

    detailAdminTransferVerificationWork = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("detail-admin-transfer-verification-work"), ParamEncrypt.encryptObject(adminRequestDto));
    }
    videoAdminTransferVerificationWork = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("video-admin-transfer-verification-work"), ParamEncrypt.encryptObject(adminRequestDto));
    }
    customerAdminTransferVerificationWork = (adminRequestDto: AdminRequestDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("customer-admin-transfer-verification-work"), ParamEncrypt.encryptObject(adminRequestDto));
    }

    getAdminUsersByType = (type: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-admin-users-by-type/").concat(ParamEncrypt.encryptData(type)));
    }
    verifyAdminByUsername = (username: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("verify-admin-username/").concat(ParamEncrypt.encryptData(username)));
    }

    getPendingJointAccountTemplateRequests = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-joint-account-template-requests"));
    }

    acceptJointAccountTemplateRequest = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("accept-joint-account-template-request/").concat(ParamEncrypt.encryptData(reference)));
    }

    getPendingIndividualAccountRequest = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-pending-individual-account-request"));
    }

    getAllFundDetails = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-fund-details"));
    }

    verifyIndividualAccountRequest = (adminRequestDto: IndividualAccountWrapperDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("verify-individual-account-request"), ParamEncrypt.encryptObject(adminRequestDto));
    }


    updateFundDetail = (fundDetailDto: FundDetailDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("update-fund-detail"), ParamEncrypt.encryptObject(fundDetailDto));
    }

    getCurrentYieldDetails = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-current-yield"));
    }

    saveOrUpdateCurrentYieldDetail = (currentYieldDetailDto: CurrentYieldDetailDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("save-or-update-current-yield"), ParamEncrypt.encryptObject(currentYieldDetailDto));

    }
    mergeJointAccountTemplateRequest = (reference: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("merge-joint-account-template-request/").concat(ParamEncrypt.encryptData(reference)));

    }
    fetchManagerSummery = (managerCode: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-manager-summary/").concat(ParamEncrypt.encryptData(managerCode)));
    }
    fetchRelationshipManagerList = (managerCode: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-relationship-manager-list/").concat(ParamEncrypt.encryptData(managerCode)));
    }

    fetchRelationshipManagerSummery = (rmCode: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-relationship-manager-summary/").concat(ParamEncrypt.encryptData(rmCode)));
    }

    fetchCustomerWiseSummaryList = (fundId: number | null, rmId: number) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-customer-wise-summary-list"), ParamEncrypt.encryptObject({
            fundId: fundId,
            rmId: rmId
        }));
    }


    fetchRelationshipManagerWiseCustomerList = (customerFilterDto: CustomerFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-relationship-manager-wise-customers"), ParamEncrypt.encryptObject(customerFilterDto));
    }


    fetchAllCustomers = (filterDto: CustomerFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("fetch-all-customers"), ParamEncrypt.encryptObject(filterDto));
    }

    fetchCustomerByCin = (cin: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("fetch-customer-by-cin/").concat(ParamEncrypt.encryptData(cin)));
    }

    fetchResyncTableList = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-re-sync-table-list"));
    }

    resyncTable = () => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("re-sync-table"));
    }
    resyncTransactionTable = (data: TransactionTableResyncDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("re-sync-transactions"), ParamEncrypt.encryptObject(data));
    }

    changeUserStatus = (userMstDto: UserMstDto) => {
        return HttpService.post(CONTEXT_PATH.concat("/user-mst-service/").concat("change-status"), ParamEncrypt.encryptObject(userMstDto));
    }

    sendUsernameAsEmail = (username: string) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("send-username-as-email/").concat(ParamEncrypt.encryptData(username)));

    }
    getCustomerJourneyStatus = (identificationValue: string, identificationsSource: number) => {
        return HttpService.get(CONTEXT_PATH.concat(SERVICE_PATH).concat("get-customer-journey-status/").concat(ParamEncrypt.encryptData(identificationValue)).concat("/").concat(ParamEncrypt.encryptData(String(identificationsSource))));

    }

    filterCustomerJourneyStatus = (filterDto: UserMstFilterDto) => {
        return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat("filter-customer-journey-status"), ParamEncrypt.encryptObject(filterDto));

    }

}

const adminService = new AdminService();
export default adminService;